"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const TypeScriptUtils_1 = require("../../Common/TypeScriptUtils");
const ChatMessageDefinition_1 = require("../ChatMessageDefinition");
class ChatMessageUtils {
    static IsContentTypeText(contentType) {
        return contentType === "" || contentType === ChatMessageDefinition_1.ChatMessageDefinition.CONTENT_TYPE_TEXT_PLAIN;
    }
    static IsContentTypeImage(contentType) {
        return !TypeScriptUtils_1.isNullOrEmpty(contentType)
            && (contentType === ChatMessageDefinition_1.ChatMessageDefinition.CONTENT_TYPE_IMG_JPEG
                || contentType === ChatMessageDefinition_1.ChatMessageDefinition.CONTENT_TYPE_IMG_PNG);
    }
    static IsContentTypeAudio(contentType) {
        return !TypeScriptUtils_1.isNullOrEmpty(contentType) &&
            (contentType === ChatMessageDefinition_1.ChatMessageDefinition.CONTENT_TYPE_AUDIO_AAC
                || contentType === ChatMessageDefinition_1.ChatMessageDefinition.CONTENT_TYPE_AUDIO_WAV
                || contentType === ChatMessageDefinition_1.ChatMessageDefinition.CONTENT_TYPE_AUDIO_WEBM);
    }
    static IsContentTypeWithThumbnail(contentType) {
        return ChatMessageUtils.IsContentTypeImage(contentType);
    }
    static IsContentTypeWithAttachment(contentType) {
        return ChatMessageUtils.IsContentTypeImage(contentType) || ChatMessageUtils.IsContentTypeAudio(contentType);
    }
    static HasContent(checker, supplier) {
        if (!checker || !supplier)
            return false;
        return checker();
    }
    static async HasContentAsync(checker, supplier) {
        if (!checker || !supplier)
            return false;
        return await checker();
    }
    static GetContent(supplier) {
        return supplier ? supplier() : new Blob();
    }
    static async GetContentAsync(supplier) {
        return supplier ? await supplier() : new Blob();
    }
    static ThumbnailName(attachmentName) { return `${attachmentName}-thumbnail`; }
    static IsThumbnailName(name) { return !TypeScriptUtils_1.isNullOrEmpty(name) && name.endsWith("-thumbnail"); }
}
exports.ChatMessageUtils = ChatMessageUtils;
//# sourceMappingURL=ChatMessageUtils.js.map